// What state a lab booking is in. Shared by Lab Overview (cards + chart) and the
// order lists, so a card's count matches the list it opens.

export type OrderOutcome = "fulfilled" | "open" | "cancelled" | "refund";
// "delayed" = still open after its scheduled date has passed
export type OutcomeFilter = OrderOutcome | "delayed";

const FULFILLED_STATUSES = ["completed", "delivered", "fulfilled", "report ready", "reportready"];
const CANCELLED_STATUSES = ["cancelled", "canceled", "rejected"];
const REFUND_STATUSES = ["refund", "refunded", "refund initiated", "refundinitiated"];

const normalize = (value: any) => String(value || "").trim().toLowerCase();

export const getOrderOutcome = (booking: any): OrderOutcome => {
  const status = normalize(booking.status);
  if (REFUND_STATUSES.includes(status) || REFUND_STATUSES.includes(normalize(booking.paymentStatus))) return "refund";
  if (CANCELLED_STATUSES.includes(status)) return "cancelled";
  if (FULFILLED_STATUSES.includes(status)) return "fulfilled";
  return "open";
};

export const isDelayedOrder = (booking: any) => {
  if (getOrderOutcome(booking) !== "open" || !booking.scheduledDate) return false;
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return new Date(booking.scheduledDate) < startOfToday;
};

export const matchesOutcome = (booking: any, filter: OutcomeFilter) =>
  filter === "delayed" ? isDelayedOrder(booking) : getOrderOutcome(booking) === filter;

export const OUTCOME_FILTER_LABELS: Record<OutcomeFilter, string> = {
  fulfilled: "Fulfilled",
  open: "In progress",
  cancelled: "Cancelled",
  refund: "Refund",
  delayed: "Delays",
};

export const isOutcomeFilter = (value: string | null): value is OutcomeFilter =>
  !!value && value in OUTCOME_FILTER_LABELS;
